import React from 'react';
import AcceptInvitation from './AcceptInvitation';

const AcceptAdminInvitation: React.FC = () => {
    return (
        <AcceptInvitation
            userType="admin"
            tableName="admin_users"
            statusField="status"
            redirectPath="/dashboard"
        />
    );
};

export default AcceptAdminInvitation;
